import { render, staticRenderFns } from "./freeKingdoms.vue?vue&type=template&id=1d59ff2d"
import script from "./freeKingdoms.vue?vue&type=script&lang=js"
export * from "./freeKingdoms.vue?vue&type=script&lang=js"
import style0 from "./freeKingdoms.vue?vue&type=style&index=0&id=1d59ff2d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports